import React, { useCallback, useEffect, useRef, useState } from 'react'
import Recorder from 'recorder-js';
import { useDispatch, useStore } from 'react-redux'
import Select, { components } from 'react-select'
import { AiOutlinePlusCircle, AiOutlineMinusCircle } from 'react-icons/ai'
import { Loader, Table } from 'rsuite'
import { FaCircleStop } from "react-icons/fa6";

import { getUserInfo } from '../../redux/actions/auth'
import { saveAndGetMediaAccessFile, saveVoiceMail } from '../../redux/actions/user'
import Header from '../CommonComponents/Header'
import { addStateToNotRecordCalls, removeStateToNotRecordCalls, getStatesToNotRecordCalls } from '../../redux/actions/caller'
import { toast } from '../CommonComponents/ToastComponent/toast'
import { CONSTANTS } from '../../utils/constants/constants';

const { Column, HeaderCell, Cell, Pagination } = Table

export const TableCell = ({ rowData, dataKey, ...props }) => {
    return (
        <Cell {...props} className="table-link list-table-cell text-black" id={rowData.id}>
            {dataKey === 'serialNo' ?
                (props?.rowKey + 1)
                :
                rowData[dataKey]
            }
        </Cell>
    )
}

export const ActionCell = ({ rowData, dataKey, onClick, ...props }) => {
    return (
        <Cell {...props} className="table-action" fixed>
            <button type="button" className={`h4 pt-2 pb-2 rounded mb-0 bg-red text-white width-100`} onClick={() => onClick(rowData)}>Remove</button>
        </Cell>
    )
}

const CallerSettings = () => {
    const dispatch = useDispatch()
    const store = useStore().getState()
    const { auth: { user } } = store
    
    const statesToAddOrRemove = [
        { label: 'Alabama', value: 'AL' },
        { label: 'Alaska', value: 'AK' },
        { label: 'Arizona', value: 'AZ' },
        { label: 'Arkansas', value: 'AR' },
        { label: 'California', value: 'CA' },
        { label: 'Colorado', value: 'CO' },
        { label: 'Connecticut', value: 'CT' },
        { label: 'Delaware', value: 'DE' },
        { label: 'Florida', value: 'FL' },
        { label: 'Georgia', value: 'GA' },
        { label: 'Hawaii', value: 'HI' },
        { label: 'Idaho', value: 'ID' },
        { label: 'Illinois', value: 'IL' },
        { label: 'Indiana', value: 'IN' },
        { label: 'Iowa', value: 'IA' },
        { label: 'Kansas', value: 'KS' },
        { label: 'Kentucky', value: 'KY' },
        { label: 'Louisiana', value: 'LA' },
        { label: 'Maine', value: 'ME' },
        { label: 'Maryland', value: 'MD' },
        { label: 'Massachusetts', value: 'MA' },
        { label: 'Michigan', value: 'MI' },
        { label: 'Minnesota', value: 'MN' },
        { label: 'Mississippi', value: 'MS' },
        { label: 'Missouri', value: 'MO' },
        { label: 'Montana', value: 'MT' },
        { label: 'Nebraska', value: 'NE' },
        { label: 'Nevada', value: 'NV' },
        { label: 'New Hampshire', value: 'NH' },
        { label: 'New Jersey', value: 'NJ' },
        { label: 'New Mexico', value: 'NM' },
        { label: 'New York', value: 'NY' },
        { label: 'North Carolina', value: 'NC' },
        { label: 'North Dakota', value: 'ND' },
        { label: 'Ohio', value: 'OH' },
        { label: 'Oklahoma', value: 'OK' },
        { label: 'Oregon', value: 'OR' },
        { label: 'Pennsylvania', value: 'PA' },
        { label: 'Rhode Island', value: 'RI' },
        { label: 'South Carolina', value: 'SC' },
        { label: 'South Dakota', value: 'SD' },
        { label: 'Tennessee', value: 'TN' },
        { label: 'Texas', value: 'TX' },
        { label: 'Utah', value: 'UT' },
        { label: 'Vermont', value: 'VT' },
        { label: 'Virginia', value: 'VA' },
        { label: 'Washington', value: 'WA' },
        { label: 'West Virginia', value: 'WV' },
        { label: 'Wisconsin', value: 'WI' },
        { label: 'Wyoming', value: 'WY' }
    ]

    const tableColumns = [
        { label: 'No.', name: 'serialNo' },
        { label: 'State Name', name: 'stateName' },
    ]

    const [isLoadingStatesData, setIsLoadingStatesData] = useState(false)
    const [statesToNotRecordCalls, setStatesToNotRecordCalls] = useState([])
    const [limit, setLimit] = useState(10)
    const [page, setPage] = useState(1)
    const [voiceMailMsg, setVoiceMailMsg] = useState('')
    const [assignedPhone, setAssignedPhone] = useState('')
    const [selectedOption, setSelectedOption] = useState('record')
    const [showTextArea, setShowTextArea] = useState(false)
    const [audioBlob, setAudioBlob] = useState(null);
    const [audioUrl, setAudioUrl] = useState(null);
    const [isRecording, setIsRecording] = useState(false);
    const [duration, setDuration] = useState(0);
    const [savingLoader, setSavingLoader] = useState(false)
    const mediaRecorderRef = useRef(null);
    const audioChunksRef = useRef([]);
    const timerRef = useRef(null);
    const audioContextRef = useRef(null);
    const recorderRef = useRef(null);
    const streamRef = useRef(null);

    const Option = (props) => {
        const isStateAdded = statesToNotRecordCalls?.find(state => state?.stateCode === props.value)
        return (
            <div onClick={() => { !isStateAdded ? handleAddStateClick(props.label, props.value) : handleRemoveStateClick(isStateAdded) }}>
                <components.Option {...props} className='d-flex align-items-center' role='button'>
                    <h3 className='text-black mb-0'>{props.label}</h3>
                    {!isStateAdded ?
                        <AiOutlinePlusCircle className='ms-auto' color="#58CF6B" size={26} />
                        :
                        <AiOutlineMinusCircle className='ms-auto' color="#FF0000" size={26} />
                    }
                </components.Option>
            </div>
        );
    };

    const headerElements = tableColumns.map((col, index) => {
        if (index === 0) {
            return (
                <Column
                    resizable
                    key={col.name}
                    width={100}
                >
                    <HeaderCell className='text-black fw-bold'>{col.label}</HeaderCell>
                    <TableCell dataKey={col.name} />
                </Column>
            )
        }
        return (
            <Column
                resizable
                key={col.name}
            >
                <HeaderCell className='fw-bold text-black'>{col.label}</HeaderCell>
                <TableCell className='text-black' dataKey={col.name} />
            </Column>
        )
    })






    const handleAddStateClick = (stateName, stateCode) => {
        setIsLoadingStatesData(true)
        dispatch(addStateToNotRecordCalls({
            stateName,
            stateCode
        })).then(states => {
            setStatesToNotRecordCalls(states)
            setIsLoadingStatesData(false)
            toast.show({
                title: 'Success',
                description: 'State to not record call added successfully!',
            })
        }).catch(() => {
            setIsLoadingStatesData(false)
            toast.show({
                title: 'Warning',
                description: 'Failed to add state to not record call!',
            })
        })
    }
    const handleRemoveStateClick = (stateData) => {
        if (stateData?.id) {
            setIsLoadingStatesData(true)
            dispatch(removeStateToNotRecordCalls(stateData?.id)).then(states => {
                setStatesToNotRecordCalls(states)
                setIsLoadingStatesData(false)
                toast.show({
                    title: 'Success',
                    description: 'State to not record call removed successfully!',
                })
            }).catch(() => {
                setIsLoadingStatesData(false)
                toast.show({
                    title: 'Warning',
                    description: 'Failed to remove state to not record call!',
                })
            })
        } else {
            toast.show({
                title: 'Warning',
                description: 'No State Id Selected!',
            })
        }
    }


    const startRecording = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            streamRef.current = stream;

            const audioContext = new (window.AudioContext || window.webkitAudioContext)({ sampleRate: 8000 });
            audioContextRef.current = audioContext;

            const recorder = new Recorder(audioContext, {
                numChannels: 1, // mono
            });

            recorderRef.current = recorder;

            await recorder.init(stream);
            recorder.start();

            audioChunksRef.current = [];
            setDuration(0);
            setIsRecording(true);

            timerRef.current = setInterval(() => {
                setDuration((prev) => prev + 1);
            }, 1000);

        } catch (error) {
            toast.show({
                title: 'Warning',
                description: 'Error occured on starting recordinf',
            });
        }
    };

    const stopRecording = async () => {
        let formData = new FormData()

        if (recorderRef.current) {
            const result = await recorderRef.current.stop();
            const { blob } = result;

            if (blob && blob.size > 0) {
                formData.append("recordedVoiceMail", blob);
                const urlResult = await dispatch(saveAndGetMediaAccessFile(formData)).then(res => res?.data?.url).catch(err => null)
                setAudioUrl(urlResult);
            } else {
                toast.show({
                    title: 'Danger',
                    description: 'Empty or Invalid Blob, Cannot Generate URL',
                });
            }

            clearInterval(timerRef.current);
            setIsRecording(false);

            streamRef.current?.getTracks().forEach(track => track.stop());
        }
    };

    const getUserInfoHandler = useCallback(() => {
        dispatch(getUserInfo(user?.id)).then((res) => {
            let audioSrc
            if (!res?.info?.voiceMailS3Url) {
                audioSrc = ''
            } else {
                audioSrc = res?.info?.voiceMailS3Url
            }

            setAudioUrl(audioSrc);
            setVoiceMailMsg(res?.info?.voiceMailMessage || '')
            setAssignedPhone(res?.info?.assignedPhoneNumber || '')
            setSelectedOption(res?.info?.voiceMailType)
            setDuration(!res?.info?.voiceMailDuration ? 0 : res?.info?.voiceMailDuration)

            if (res?.info?.voiceMailType === "textToSpeech") {
                setShowTextArea(true)
            } else {
                setShowTextArea(false)
            }

        }).catch(err => {
            toast.show({
                title: 'Danger',
                description: 'Unable To Get User Info',
            });
        })
    }, [])

    const handleOptionChange = (e) => {
        setSelectedOption(e.target.value)
        if (e.target.value === 'record') {
            setShowTextArea(false)
        } else if (e.target.value === 'textToSpeech') {
            setShowTextArea(true)
        }
    }

    const onSave = () => {
        setSavingLoader(true)
        if (!voiceMailMsg && !selectedOption) {
            toast.show({
                title: 'Warning',
                description: 'No Voicemail message',
            });
            return
        }

        dispatch(saveVoiceMail({ voiceMailType: selectedOption, voiceMailMessage: voiceMailMsg, voiceMailDuration: duration, voiceMailS3Url: audioUrl})).then((res) => {
            setSavingLoader(false)
            toast.show({
                title: 'Success',
                description: 'Voicemail Saved Successfully',
            });
        }).catch((err) => {
            toast.show({
                title: 'Warning',
                description: 'Unable To Save Voicemail',
            });
        })
    }

    const onCancel = async (req, res) => {
        setShowTextArea(false)
    }

    useEffect(() => {
        setIsLoadingStatesData(true)
        dispatch(getStatesToNotRecordCalls()).then(states => {
            setStatesToNotRecordCalls(states)
            setIsLoadingStatesData(false)
        }).catch(() => {
            setIsLoadingStatesData(false)
        })
    }, [])

    useEffect(() => {
        getUserInfoHandler()
    }, [])
    console.log("statesToNotRecordCalls", statesToNotRecordCalls)
    const paginatedData = statesToNotRecordCalls?.partnerSubmissions?.sort((a, b) => {
    }).slice(limit * (page - 1), limit * page)

    return (
        (<div className="caller-settings-component padding-left d-flex justify-contents-between w-100 column-gap-5 h-100">
            <div className=' w-50 h-100 p-3'>
                <Header header={'Caller Settings'} />
                <div className='border rounded w-100 h-75 p-3 mt-5'>
                    <p className='fs-4 fw-bold text-black'>Assigned Phone Number</p>
                    <input className='form-control' value={user?.assignedPhoneNumber} readOnly style={{ height: 48 }} />
                    <div className='w-100 h-75 p-3 mt-5'>
                        <p className='fs-4 fw-bold text-black'>Record Voicemail</p>
                        <p className='fs-5 fw-bold text-black mb-0  '>Select Type</p>
                        <div className="row w-100 m-auto">
                            <div className='col-6 d-flex justify-content-between'>
                                <div className='w-100 d-flex column-gap-3'>
                                    <label style={{ fontSize: 14, fontWeight: 400 }} className="text-black d-flex align-items-center" >
                                        <input
                                            className="me-3"
                                            type="radio"
                                            value="record"
                                            checked={selectedOption === 'record'}
                                            onChange={handleOptionChange}
                                        />
                                        Record
                                    </label>


                                    <label style={{ fontSize: 14, fontWeight: 400 }} className="text-black d-flex align-items-center">
                                        <input
                                            className="me-3"
                                            type="radio"
                                            value="textToSpeech"
                                            checked={selectedOption === 'textToSpeech'}
                                            onChange={handleOptionChange}
                                        />
                                        Text To Speech
                                    </label>
                                </div>
                            </div>
                            <div className='col-6 d-flex justify-content-between p-0'>
                                <div className='w-100 d-flex justify-content-end'>
                                    {audioUrl && selectedOption === "record" && <audio key={audioUrl} controls src={audioUrl} />}
                                </div>
                            </div>
                        </div>
                        <div className='mt-4'>
                            {
                                selectedOption === 'textToSpeech' ? <textarea className='form-control fs-4' style={{ height: 48 }} value={voiceMailMsg} onChange={(e) => { setVoiceMailMsg(e.target.value) }} />
                                    : selectedOption === 'record' ? <div className={`d-flex ${isRecording ? 'justify-content-between' : 'justify-content-end'} border rounded p-2`}>
                                        {!isRecording ?
                                            <button
                                                className='rounded-circle text-white'
                                                style={{ height: 30, width: 30, backgroundColor: '#E11C1C' }}
                                                onClick={() => { setIsRecording(!isRecording); startRecording() }}>
                                                REC
                                            </button>
                                            :
                                            (
                                                <button className="rounded-circle text-white w-100" style={{ height: 30, width: 30 }} onClick={stopRecording}>
                                                    <div className="d-flex justify-content-between w-100">
                                                        <p className="w-75 m-0 text-black m-0 fs-4 fw-bold d-flex align-items-center justify-content-center">{new Date(duration * 1000).toISOString().substr(14, 5)}</p>
                                                        <FaCircleStop size={28} color="#E11C1C" />
                                                    </div>
                                                </button>
                                            )
                                        }
                                    </div> : null
                            }
                            <div className='d-flex column-gap-3 justify-content-end mt-3'>
                                <button className='report_small_button_grey' onClick={() => { onCancel() }}>Cancel</button>
                                <button className='report_small_button_success' onClick={() => { onSave() }}>{savingLoader ? <Loader /> : 'Save'}</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            {user?.roleName === CONSTANTS.ROLE_NAME.ADMIN && user?.roleId === CONSTANTS.ROLE_ID.ADMIN && <div className='w-50 h-100 p-3'>
                <Header header={'Add States Not To Call'} />
                <div className='d-flex flex-column justify-content-end border w-100 h-75 p-3 mt-5'>
                    <Select
                        classNamePrefix='react-select-selector'
                        className="h4 mb-0 text-black w-50   states-to-not-record-call ms-auto"
                        placeholder='Add state to not record'
                        options={statesToAddOrRemove.map(state => {
                            return {
                                label: state.label,
                                value: state.value
                            }
                        })}
                        styles={{
                            container: (base) => ({
                                ...base,
                                zIndex: 3
                            }),
                            option: (base) => ({
                                ...base,
                                cursor: 'pointer'
                            })
                        }}
                        components={{ Option }}
                        value={null}
                    />
                    <div className='border mt-3 h-100' style={{ overflowY: 'scroll' }}>
                        <Table
                            virtualized={true}
                            data={paginatedData}
                            autoHeight
                            affixHeader={true}

                        >
                            {headerElements}
                            <Column
                                width={120}
                                fixed="right"
                                key="action"
                            >
                                <HeaderCell className='h4 mb-0 text-black fw-bold'>Action</HeaderCell>
                                <ActionCell
                                    onClick={handleRemoveStateClick}
                                />
                            </Column>
                        </Table>
                        <div className="pagination">
                            <Pagination
                                prev
                                next
                                first
                                last
                                showInfo
                                maxButtons={5}
                                lengthMenu={[
                                    { label: '5', value: 5 },
                                    { label: '10', value: 10 },
                                    { label: '25', value: 25 },
                                    { label: '50', value: 50 },
                                ]}
                                displayLength={limit}
                                total={statesToNotRecordCalls.length}
                                limit={limit}
                                activePage={page}
                                onChangePage={(event) => { setPage(event) }}
                                onChangeLength={(limit) => { setLimit(limit) }}
                            />
                        </div>
                    </div>

                    <div>

                    </div>
                </div>
            </div>}
        </div>)
    )
}

export default CallerSettings
